import { useContext, useState } from "react";
import { CollapsableConfiguration } from "./OtherConfigurationItems/CollapsableConfiguration";
import { SearchBar } from "./SearchBar";
import { TranslationService } from "../../../services/TranslationService";
import ConfigurationContext from "../ConfigurationContext";
import Loading from "../../shared/components/Loading";
import CompanyService from "../../../services/CompanyService";
import { parseIntOrDefault } from "../../../utils/ParseUtils";
import ActivityService from "../../../services/ActivityService";
import ModalService from "../../shared/bootstrap/modal/Modal";

const OtherConfiguration = () => {
  const { otherConfigurationList } = useContext(ConfigurationContext);
  const [valueSearch, setValueSearch] = useState("");

  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <h4 className="mb-2">{TranslationService.translate.OtherSettings}</h4>
        <div className="card">
          <SearchBar onSearch={setValueSearch} />
          <table className="table shadow-hover collapsableFolder">
            <tbody>
              {otherConfigurationList ? (
                otherConfigurationList?.map(
                  ({ titleGroup, childrenGroup }, index) => (
                    <CollapsableConfiguration
                      key={index + titleGroup}
                      titleGroup={titleGroup}
                      children={childrenGroup}
                      valueSearch={valueSearch}
                    />
                  )
                )
              ) : (
                <Loading />
              )}
            </tbody>
          </table>
          {parseIntOrDefault(CompanyService.getCompanyToken()?.adminid, 0) >
            0 && (
            <button
              className="btn btn-outline-primary w-250px"
              onClick={() =>
                ModalService.showDefaultModal({
                  acceptButtonLabel: "Marcar",
                  message:
                    "Está seguro de marcar todos los emails como leídos?",
                  onAcceptClick: ActivityService.markAllAsRead
                })
              }
            >
              Marcar emails como leídos
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtherConfiguration;
